import styled from "styled-components";

const getBorderColor = (isFine, isError) => {
  if (isFine) return "#26CC83";
  if (isError) return "#CC2626";
  else {
    return "#E5E9FA";
  }
};

const getSvgColor = (isFine, isError) => {
  if (isFine) return "#26CC83";
  if (isError) return "#CC2626";
  else {
    return "#a7a7be";
  }
};

const getCircleColor = (isFine, isError) => {
  if (isFine) return "#26CC83";
  if (isError) return "#CC2626";
  else {
    return "#E5E9FA";
  }
};

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background: none;
  border: 1px solid;
  border-color: ${props => getBorderColor(props.isFine, props.isError)};
  border-radius: 10px;
  width: 100%;
  padding: 0 7px;
  margin: 10px 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 7px;

  .spinner-border {
    color: #ced6f6;
  }

  svg path,
  svg circle {
    stroke: ${props => getSvgColor(props.isFine, props.isError)};
  }
`;

export const EyeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 7px;
  cursor: pointer;
`;

export const InputField = styled.input`
  width: 100%;
  height: 40px;
  background: none;
  border: none;
  font-size: 13px;
  font-family: "EstedadEn";
  outline: none;
  text-align: ${props => (props.direction === "ltr" ? "left" : "right")};
  direction: ${props => (props.direction === "ltr" ? "ltr" : "rtl")};

  ::placeholder {
    text-align: right;
    color: #a7a7be;
    direction: rtl !important;
  }
`;

export const Circle = styled.div`
  width: 12px;
  height: 12px;
  background: ${props => getCircleColor(props.isFine, props.isError)};
  border-radius: 50%;
`;

export const PlaceHolder = styled.div`
  font-weight: 100;
  color: #a7a7be;
  font-size: 14px;
  direction: ltr;
  margin-left: 10px;
`;
